<script setup lang="ts">
    import ContentCollapse from '@/js/components/Common/ContentCollapse.vue'
    import { computed, onMounted } from 'vue'
    import { useTooltipStore } from '@/js/stores'
    import { Tooltip } from '@/js/model'

    const tooltipStore = useTooltipStore()

    const isLoading = computed(() => tooltipStore.isLoading)

    const tooltips = computed(() => {
        return tooltipStore.tooltips
    })

    onMounted(async () => {
        await Promise.all([tooltipStore.fetchTooltips()])
    })

    const saveTooltip = (tooltip: Tooltip) => {
        tooltipStore.updateTooltip(tooltip)
    }
</script>

<template>
    <div>
        <h2 class="mt-3 mx-2">Verwaltung der Tooltips</h2>

        <content-collapse title="Tooltips" collapse-key="tooltip-control-list">
            <template #badge>
                <v-progress-circular
                    v-if="isLoading"
                    indeterminate
                    color="silvergrey"
                    class="ml-2"
                    size="14"
                />
            </template>
            <div class="mt-2">
                <common-single-edit
                    v-for="(item, index) in tooltips"
                    :data-test="`edit-tooltip-${item.id}`"
                    :key="index"
                    :title="item.modulFeld"
                    :edit-key="item.modulFeld"
                    :entry="item.text"
                    allow-edit
                    @text-saved="saveTooltip(item)"
                >
                    <template #edit-component>
                        <common-my-markup-editor v-model:content="item.text" />
                    </template>
                    <template #preview-component>
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <div v-html="item.text" />
                    </template>
                </common-single-edit>
            </div>
        </content-collapse>
    </div>
</template>

<style scoped lang="scss"></style>
